import { Redirect } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { SelectPolicyOwner } from './components'
import { canProceedToCoveragePlan } from 'quick-quote/selectors/next-tab-proceeding'
import { getAvailableRiderCodes } from 'quick-quote/product-common/coverage-plan/selectors'
import { toggleRider } from 'quick-quote/product-common/coverage-plan/actions'
import { getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'

export const SelectPolicyOwnerContainer = () => {
  const dispatch = useDispatch()
  const riderCodes = useSelector(getAvailableRiderCodes)
  const canProceedToSelectOwnerPolicy = useSelector(canProceedToCoveragePlan)
  const selectedDisplayProductCode = useSelector(getSelectedDisplayProductCode)

  if (!selectedDisplayProductCode) {
    return <Redirect to="/" push />
  }

  return (
    <SelectPolicyOwner
      riderCodes={riderCodes}
      canProceedToSelectOwnerPolicy={canProceedToSelectOwnerPolicy}
      selectedDisplayProductCode={selectedDisplayProductCode}
      toggleRider={(rider) => dispatch(toggleRider(rider))}
    />
  )
}
